import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { LoadingState } from '../components/index.js';
import { useCurrentUser } from '../lib/auth.js';

/**
 * Client-side route protection — **UX only**. The server independently
 * authorizes every request regardless of what the client believes
 * (TECH_STACK §40: "Frontend route protection is for UX only. It is not
 * authorization."); this component exists purely to redirect an
 * unauthenticated visitor to `/login` instead of rendering a page that
 * would immediately fail every request it makes.
 */
export function ProtectedRoute() {
  const { data: user, isPending } = useCurrentUser();
  const location = useLocation();

  if (isPending) {
    return <LoadingState label="Checking your session…" />;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
